import {computed} from 'vue'
import {useWebSocket} from '@vueuse/core'
import {useChatStore} from '@/stores/chat'

const url = process.env.VUE_APP_WS_PATH
const urlWs = process.env.VUE_APP_WS_URL // TODO: Replace to reseller URL

const options = {
    immediate: false,
    autoReconnect: {
        delay: 2500
    },
    heartbeat: {
        message: '{"data": { "type" : "users_online" }, "type": "users_online", "channel": "internalChat"}',
        interval: 30000,
        pongTimeout: 30000
    }
}

let wsChat = useWebSocket(`${urlWs}/${url}?token=`, options)

export default function useWebSocketChat() {
    const chatStore = useChatStore()

    const status = computed(() => wsChat.status.value)

    const data = computed(() => wsChat.data.value)

    const wsInfo = computed(() => wsChat.ws.value)

    const send = (message: string) => {
        wsChat.send(message)
    }

    const close = () => {
        wsChat.close()
    }

    function open() {
        wsChat = useWebSocket(`${urlWs}/${url}?token=${encodeURIComponent(chatStore.token)}`, options)
        wsChat.open()
    }

    return {status, data, send, open, close, wsInfo, wsChat}
}
